import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Portlet } from '@shared/ui/components/Portlet';

import { DisableTwoFactorAuthenticationButton } from '@admin/users/components/DisableTwoFactorAuthenticationButton';

import { GROUPS_ACTIONS } from '../../../../redux/groups/actions';
import { selectGroups } from '../../../../redux/groups/selectors';
import { USERS_ACTIONS } from '../../../../redux/users/actions';
import { selectActiveUser, selectActiveUserPermissions, userUpdating } from '../../../../redux/users/selectors';
import UserForm from '../../../forms/UserForm';
import AdminSubHeader from '../../../layouts/partials/AdminSubheader';

class UsersCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    groups: PropTypes.array,
    user: PropTypes.object,
    userPermissions: PropTypes.array,
    loadUser: PropTypes.func,
    loadUserPermission: PropTypes.func,
    loadGroups: PropTypes.func,
    updateUser: PropTypes.func,
    match: PropTypes.object,
    isUpdating: PropTypes.bool,
  };

  UNSAFE_componentWillMount() {
    this.props.loadUser();
    this.props.loadUserPermission();
    this.props.loadGroups();
  }

  _handleSubmit(values) {
    const data = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      permissionPresetId: values.group,
      password: values.password || null,
    };

    const permissions = {
      permissionIds: values.permissions,
    };

    this.props.updateUser(this.props.match.params.id, data, permissions);
  }

  render() {
    const { user, userPermissions, groups, isUpdating } = this.props;

    const breadcrumbs = [
      {
        title: 'Users',
        to: '/admin/users',
      },
    ];

    return [
      <AdminSubHeader title="Edit User" key="subheader" breadcrumbs={breadcrumbs} />,
      <div className="m-content" key="content">
        <UserForm
          onSubmit={this._handleSubmit}
          groups={groups}
          user={user}
          userPermissions={userPermissions}
          formSubmitting={isUpdating}
        />
        <div className="grid xl:grid-cols-2 gap-6">
          <Portlet icon="lock" title="Two Factor Authentication" key="two-factor" innerClassName="flex flex-col gap-3">
            {user.twoFactorEnabled ? (
              <>
                <p>Two Factor Authentication is enabled for this user.</p>
                <div>
                  <DisableTwoFactorAuthenticationButton user={user} onDisable={() => this.props.loadUser()} />
                </div>
              </>
            ) : (
              <div>Two Factor Authentication is not enabled for this user.</div>
            )}
          </Portlet>
        </div>
      </div>,
    ];
  }
}

const mapStateToProps = (state, props) => ({
  user: selectActiveUser(state),
  userPermissions: selectActiveUserPermissions(state),
  groups: selectGroups(state),
  isUpdating: userUpdating(state),
});

const mapDispatchToProps = (dispatch, props) => ({
  loadGroups: () => dispatch(GROUPS_ACTIONS.loadAllRequest()),
  loadUser: () => dispatch(USERS_ACTIONS.loadRequest(props.match.params.id)),
  updateUser: (id, values, permissions) => dispatch(USERS_ACTIONS.updateRequest(id, values, permissions)),
  loadUserPermission: () => dispatch(USERS_ACTIONS.loadPermissionsRequest(props.match.params.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersCreate);
